import { render } from "./WeekDaysModal.vue?vue&type=template&id=08261534&scoped=true"
import script from "./WeekDaysModal.vue?vue&type=script&lang=js"
export * from "./WeekDaysModal.vue?vue&type=script&lang=js"

import "./WeekDaysModal.vue?vue&type=style&index=0&id=08261534&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08261534"]])

export default __exports__